
































































import Vue, { PropType } from 'vue'
import SubjectTitle from '../atoms/SubjectTitle.vue'
import ContentItem from '../molecules/ContentItem.vue'
import BaseText from '../atoms/BaseText.vue'
import { ManabiContent } from '@/types/ManabiContent'
import { Grade } from '@/types/Contract'

// えい語の subject_id
const ENGLISH_SUBJECT_ID = 5
// 注釈表示対象の学年ID
const GRADE_2_ID = 2

export type Subject = {
  name: string
  subject_id: number
  furigana: string
  anchor: string
  color: string
  backgroundColor: string
}

export default Vue.extend({
  components: { SubjectTitle, ContentItem, BaseText },
  props: {
    subjects: {
      type: Array as () => Subject[],
    },
    icons: {
      type: Object,
    },
    selectedGrade: {
      type: Object as PropType<Grade | null>,
      default: null,
    },
    noticeAlign: {
      type: String as () => 'center' | 'left',
      default: 'center',
    },
  },
  computed: {
    filteredContents(
      this: {
        $store: {
          state: {
            year: number,
            month: number,
            contents: Record<
            string, {contents: ManabiContent[]}
            >
          }
        }
      }
    ): ManabiContent[] {
      const key =
        this.$store.state.year.toString() +
        ('0' + this.$store.state.month).slice(-2)
      const data = this.$store.state.contents[key]
      return data ? data.contents : []
    },
    opendFilterdContents(
      this: {
        filteredContents: ManabiContent[]; $store: {
          state: {
            currentDate: string
          }
        }
      }
    ): ManabiContent[] {
      return this.filteredContents.filter(f => {
        if (!f.start_date) return true
        const start = new Date(f.start_date)
        start.setHours(start.getHours() - 9)
        return start <= new Date(this.$store.state.currentDate)
      })
    },
    notOpendFilterdContents() {
      return this.filteredContents.filter(f => {
        if (!f.start_date) return false
        const start = new Date(f.start_date)
        start.setHours(start.getHours() - 9)
        return start > new Date(this.$store.state.currentDate)
      })
    }
  },
  methods: {
    // 教科に紐づくコンテンツが存在するか
    hasContentForSubject(subject: Subject): boolean {
      return this.filteredContents.some(c => c.subject_id === subject.subject_id)
    },
    // 小2 えい語の注釈を表示すべきか
    shouldShowGrade2EnglishNotice(
      this: {
        filteredContents: ManabiContent[];
        opendFilterdContents: ManabiContent[];
        notOpendFilterdContents: unknown;
        selectedGrade: Grade | null;
        hasContentForSubject: (subject: Subject) => boolean;
      },
      subject: Subject
    ): boolean {
      return (
        subject.subject_id === ENGLISH_SUBJECT_ID
        && this.selectedGrade?.id === GRADE_2_ID
        && this.hasContentForSubject(subject)
      )
    },
    opendFilterdContentsAlign(
      this: {
        opendFilterdContents: ManabiContent[]
        isMd12: (content: ManabiContent, contents: ManabiContent[], isLeft: boolean) => boolean
      },
      subject_id: number
    ): ManabiContent[] {
      const filtered = this.opendFilterdContents.filter(
        f => f.subject_id == subject_id
      )
      let total = 0
      return filtered.map(content => {
        const isLeft = total % 2 === 0
        const isMd12 = this.isMd12(content, filtered, isLeft)
        total += isMd12 ? 2 : 1
        return { ...content, isMd12 }
      })
    },
    isMd12(content: ManabiContent, contents: ManabiContent[], isLeft: boolean) {
      // 表示開始日を過ぎていない場合は2列表示
      const start_date = content.start_date ? new Date(content.start_date) : null
      if (start_date) start_date.setHours(start_date.getHours() - 9)
      if (start_date && start_date > new Date(this.$store.state.currentDate)) return false

      // 後続
      const contentIndex = contents.indexOf(content)
      const successor = contentIndex <= contents.length - 2 ? contents[contentIndex + 1] : null

      // 小見出しが変わる直前(=後続に見出しが入っている) かつ左側の列なら幅いっぱい使って表示
      const isLastOfGroup = !successor || successor.headline_short || successor.headline_middle
      if (isLastOfGroup && isLeft) {
        return true
      }
      // それ以外なら2列表示
      return false
    }
  },
  mounted() {
    this.$emit('registerRefs', this.$refs)
  }
})
